export default __webpack_public_path__ + "static/media/twitter.14401a6d.svg";